export const VENDOR_MAP = {
  PERSHING: 700,
  PERSHING_COMPONENT: 701,
  EDUCATION_PLANNING_CENTER: 1100,
  EDUCATION_PLANNING_CENTER_UA: 1200,
  WALL_STREET_JOURNAL: 1300
};
